import type { ReactiveController, ReactiveControllerHost } from 'lit'

interface Options<T> {
  channelName: string
  onMessage: (message: T) => void
  enabled?: () => boolean
}

const defaultEnabled = () => true

export class BroadcastChannelController<T> implements ReactiveController {
  private channel?: BroadcastChannel
  private options: Required<Options<T>>

  constructor(host: ReactiveControllerHost, options: Options<T>) {
    host.addController(this)
    this.options = { enabled: defaultEnabled, ...options }
  }

  hostConnected(): void {
    if (typeof BroadcastChannel !== 'undefined') {
      this.channel = new BroadcastChannel(this.options.channelName)
      this.channel.addEventListener('message', this)
    }
  }

  hostDisconnected(): void {
    this.channel?.removeEventListener('message', this)
    this.channel?.close()
  }

  handleEvent(event: MessageEvent<T>) {
    if (this.options.enabled()) {
      this.options.onMessage(event.data)
    }
  }

  post(message: T) {
    if (this.options.enabled()) {
      this.channel?.postMessage(message)
    }
  }
}
